import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaptchetatAngularComponent } from 'captchetat-angular';
import { ToasterSharedService } from 'projects/sirc-lib/src/lib/services/shared/toaster-shared.service';
import { TOAST_SOURCE, TYPE_TOAST } from 'sirc-lib';
import { TemporaryDemandService } from '../../../core/services/temporary-demand.service';
import { Captcha } from '../../../shared/model/captcha.model';
import {
  TitleService,
  TitleState,
} from '../../../shared/service/title.service';
import { environment } from 'projects/sirc-public/src/environments/environment';

@Component({
  selector: 'app-dialog-create-demand',
  templateUrl: './dialog-create-demand.component.html',
  styleUrls: ['./dialog-create-demand.component.scss'],
})
export class DialogCreateDemandComponent implements OnInit {
  @ViewChild(CaptchetatAngularComponent) captchetatComponent: CaptchetatAngularComponent;

  urlBackend: string = environment.hrefBase + '/api/captcha/get';
  nomCaptcha: string = 'captchaFR';
  altImage: string = 'alternative alt pour image';

  public createForm: UntypedFormGroup;

  public isRequestSent = false;

  public urlPdfSalProtect: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly toasterService: ToasterSharedService,
    private readonly temporaryDemandService: TemporaryDemandService,
    private readonly titleService: TitleService,
  ) {}

  ngOnInit(): void {
    this.createForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.email,
      ]),
      captchaCode: new UntypedFormControl('', [
         Validators.required,
         Validators.pattern('^[a-zA-Z0-9]{1,12}$')
        ]),
    });
    this.urlPdfSalProtect = this.data.pdfSalarieProtegeLien;
  }

  /**
   * Submit the request to create a new demand
   */
  public submitCreationDemand(): void {
    let captcha = new Captcha(
      this.captchetatComponent.getIdCaptcha(),
      this.captchaCodeFormControl.value,
    );

    this.temporaryDemandService
      .initCreationDemande(this.emailFormControl.value, captcha)
      .subscribe({
        next: (result) => {
          if (result === false) {
            this.captchetatComponent.reloadCaptcha();
            this.toasterService.create(TOAST_SOURCE.TELE, {
              type: TYPE_TOAST.ERREUR,
              title: 'Erreur',
              body: 'La validation du captcha a échoué. Veuillez réessayer.',
            });
          } else {
            this.isRequestSent = true;
            this.titleService.changeTitle(TitleState.DEMANDE_CREATE);
            this.toasterService.create(TOAST_SOURCE.TELE, {
              type: TYPE_TOAST.SUCCES,
              title: 'Succès',
              body: 'Votre demande a bien été envoyée.',
            });
          }
        },
        error: (error) => {
          this.titleService.changeTitle({
            value:
              TitleState.SERVER_ERROR.value + TitleState.DEMANDE_CREATE.value,
          });
          this.toasterService.create(TOAST_SOURCE.TELE, {
            type: TYPE_TOAST.ERREUR,
            title: error.statusText,
            body: error.error.message,
          });
        },
      });
  }

  /**
   * FormControl Getters
   */
  public get emailFormControl(): UntypedFormControl {
    return this.createForm.get('email') as UntypedFormControl;
  }

  public get captchaCodeFormControl(): UntypedFormControl {
    return this.createForm.get('captchaCode') as UntypedFormControl;
  }

  public handleReloadCaptcha(event: boolean) {
    if (event) {
      this.createForm.get('captchaCode').setValue('');
    }
  }
}
